import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getCsrfToken, MetaTags, MetaTagsService } from '@mode/shared/util-js';
import { NotebookResource } from '@mode/legacy/types-hal-resource';

@Injectable({
  providedIn: 'root',
})
export class NotebookClientService {
  constructor(
    private http: HttpClient,
    private metaTags: MetaTagsService
  ) {}

  createNotebook(reportToken: string): Observable<NotebookResource> {
    const orgId = this.metaTags.getTag(MetaTags.OwnerUsername);
    const apiUrl = `api/${orgId}/notebooks`;

    const embedParams = [
      'perspective_python_sessions',
      'python_cells',
      'new_python_cell',
      'new_python_session',
      'new_python_cell_batch_run',
      'last_report_run',
      'report',
    ];

    const params = embedParams.reduce((acc, key) => acc.set(`embed[${key}]`, '1'), new HttpParams());

    const body = {
      report_token: reportToken,
      python_notebook: { doc_cells: true },
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': getCsrfToken(window.document) ?? '',
    });

    return this.http.post<NotebookResource>(apiUrl, body, { params, headers });
  }
}
